import Vue from "vue";


import "core-js/stable";
import "regenerator-runtime/runtime";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/global.scss'
import axios from 'axios'

import store from "./store";
import App from "./App.vue";
import router from "./router";

import '@wangeditor/editor/dist/css/style.css'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

import htmlToPdf from '@/util/htmlToPdf'

Vue.use(htmlToPdf)

Vue.config.productionTip = false;

// 全局方法挂载
Vue.prototype.$axios = axios

Vue.use(ElementUI);

//全局路由改变前钩子
router.beforeEach((to, from, next) => {
  window.document.title = "轻研 - " + (to.meta.title ?? "");

  // if (to.path == '/login') {
  //   localStorage.setItem("loginUrlReferrer", router.currentRoute.fullPath)
  // }

  //机构用户IP登录，不允许访问用户中心和控制台
  if (store.state.logined && store.state.userInfo && store.state.userInfo.type === 1 &&
    (to.path.startsWith("/console/") || to.path.startsWith("/user/"))
  ) {
    next("/");
  }

  if (to.meta.needLogin) {
    if (store.state.logined) {
      if (window._hmt) {
        if (to.path) {
          window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
      }

      next();
    } else {
      if (window._hmt) {
        if (to.path) {
          window._hmt.push(['_trackPageview', '/#/login?url=' + to.fullPath])
        }
      }

      next({
        path: "/login",
        query: {
          url: to.fullPath
        }
      });
    }
  } else {
    if (window._hmt) {
      if (to.path) {
        window._hmt.push(['_trackPageview', '/#' + to.fullPath])
      }
    }

    next();
  }
});

import Share from 'vue-social-share';
Vue.use(Share);

new Vue({
  axios,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
